import styled from '@emotion/styled';
import { ToggleGroup, tokens } from '@hotjar/hotsauce';

import { useTranslation } from 'react-i18next';
import { Device } from '../constants';

const Wrapper = styled('div')`
  ${tokens.flexCenter};
  margin: ${tokens.spacer.x2} auto 0;
`;

interface DeviceSelectorProps {
  onDeviceSelect: (device: Device) => void;
  selectedDevice: Device;
}

export const DeviceSelector = ({
  onDeviceSelect,
  selectedDevice,
}: DeviceSelectorProps): JSX.Element => {
  const { t } = useTranslation('feedback');
  return (
    <Wrapper>
      <ToggleGroup
        description={t('wizard.preview.device.description')}
        onChange={(value) => onDeviceSelect(value as Device)}
        selectedValue={selectedDevice}
      >
        <ToggleGroup.Toggle icon="device_desktop" value={Device.DESKTOP}>
          {t('wizard.preview.device.desktop')}
        </ToggleGroup.Toggle>
        <ToggleGroup.Toggle icon="device_phone" value={Device.PHONE}>
          {t('wizard.preview.device.phone')}
        </ToggleGroup.Toggle>
      </ToggleGroup>
    </Wrapper>
  );
};
